import {useEffect, useState} from 'preact/hooks';
import {getBceAuthInfo} from 'utils';
import {Ioc} from '@baidu/bce-decorators';
import {UDynamicService} from '@baidu/bce-services';

import {useQfScreen, useQfScroll} from '../comp/utils/hook';
import userinfo from '~/utils/userInfo';
import {header} from '~/locals/qianfan/index';
import {ULoginModal} from '../comp/ULoginModal';
import {UActivateModal} from '../comp/UActivateModal';
import {ArrowIcon, nav_btn_left, nav_btn_right} from '../comp/commonCom';
import {ajax, sendMonitor, findConsoleHref} from '~/utils/util';
import {getEnv, getHref} from '~/utils/getEnv';
import {pushProduct2Crm} from '~/utils/pushProduct2Crm';
import Tooltip from '~/components/Tooltip';
import mbLogo from '~/assets/wenxin/mb-logo.png';
import mbUser from '~/assets/qianfan/mb-user.svg';
import mbMenu from '~/assets/qianfan/mb-more.svg';
import closeMenu from '~/assets/qianfan/mb-close.svg';
import backIcon from '~/assets/qianfan/zhinengyun.svg';
import backIconMobile from '~/assets/qianfan/zhinengyun.png';

const offset = 10;
const env = getEnv();
const href = getHref();

const PopoverItem = ({item}) => {
    const [isPopoverVisible, setIsPopoverVisible] = useState(false);

    return (
        <a href={item.href} rel="noopener noreferrer" target="_blank" {...item.trackInfo}>
            <div
                key={item.id}
                className={`${item.class} popover-item-wrapper`}
                style={{position: 'relative'}}
                onMouseEnter={() => setIsPopoverVisible(true)}
                onMouseLeave={() => setIsPopoverVisible(false)}
            >
                <img src={item.text} alt="前往智能云官网" />
                {isPopoverVisible && (
                    <div className={`website-popover ${isPopoverVisible ? '' : ''}`}>前往智能云官网</div>
                )}
            </div>
        </a>
    );
};

const Header = props => {
    const [userInfo, setUserInfo] = useState({});
    const [isNamed, setIsNamed] = useState(true);
    const [logoutShow, setLogoutShow] = useState(false);
    const [isMenuShow, setIsMenuShow] = useState(true);
    const [leftBtnShow, setLeftBtnShow] = useState(false);
    const [rightBtnShow, setRightBtnShow] = useState(false);
    const {screenWidth} = useQfScreen();
    const {isMobile} = useQfScroll('qf-header');

    const {bannerRef} = props;
    const {logo, navList, buttonGroupRight} = header;
    const backInfo = buttonGroupRight[2];

    const handleMouseEnter = () => {
        const target = document.querySelector('.menu-popover');
        target.classList.add('hover-cls');
    };

    const handleMouseLeave = () => {
        const target = document.querySelector('.menu-popover');
        target.classList.remove('hover-cls');
    };

    const checkAccount = () => {
        ajax({
            url: '/api/account/status',
            type: 'GET',
            dataType: 'json',
            contentType: 'application/json',
            success: response => {
                try {
                    if (typeof response === 'string') {
                        response = JSON.parse(response);
                    }
                    if (response && response.success && response.result && response.result.code === 201) {
                        // 未激活
                        Ioc(UDynamicService).open({
                            component: UActivateModal,
                            props: {
                                maskClosable: false,
                                onOk: () => {
                                    sendMonitor({
                                        category: 'iframe',
                                        name: '激活',
                                        value: '完成激活',
                                        action: 'popup'
                                    });
                                }
                            }
                        });
                        sendMonitor({
                            category: 'iframe',
                            name: '激活',
                            value: '弹出激活',
                            action: 'popup'
                        });
                    }
                } catch (e) {
                    console.error('账号状态获取', e);
                }
            }
        });
    };

    // 登录
    const handleLogin = (e, href) => {
        e.preventDefault();
        Ioc(UDynamicService).open({
            component: ULoginModal,
            props: {
                maskClosable: true,
                href,
                onOk: info => {
                    sendMonitor({
                        category: 'iframe',
                        name: '登录',
                        value: `完成登录${info.activateSuccess ? '并完成激活' : ''}`,
                        action: 'popup'
                    });
                    userinfo.init(
                        () => {
                            if (info.activateSuccess || info.regSuccess) {
                                // 直接在iam的登录流程里完成了激活，不需要再打开激活弹层，直接推送线索
                                // 如果是UC注册，一定会激活，直接推送线索
                                pushProduct2Crm();
                            } else {
                                checkAccount();
                            }
                        },
                        false,
                        true
                    );
                },
                onCancel: () => {
                    userinfo.init(
                        info => {
                            info.hasLogin && checkAccount();
                        },
                        false,
                        true
                    );
                }
            }
        });
        sendMonitor({
            category: 'iframe',
            name: '登录',
            value: '弹出登录',
            action: 'popup'
        });
    };

    const handleMenuClick = () => {
        const menuPopover = document.querySelector('.menu-popover-wrapper');
        menuPopover.classList.toggle('menu-popover-show');
        setIsMenuShow(!isMenuShow);
    };

    const handleUserClick = () => {
        const menuPopover = document.querySelector('.mobile-menu-popover');
        menuPopover.classList.toggle('menu-popover-show');
        setLogoutShow(!logoutShow);
    };

    const handleScrollLeftClick = () => {
        const scrollDom = document.querySelector('.nav-scroll ul');
        scrollDom.scrollTo({left: 0, behavior: 'smooth'});
        setRightBtnShow(true);
        setLeftBtnShow(false);
        scrollDom.style.marginLeft = '0';
    };

    const handleScrollRightClick = () => {
        const scrollDom = document.querySelector('.nav-scroll ul');
        const width = scrollDom.getBoundingClientRect().width;
        scrollDom.scrollTo({left: scrollDom.scrollWidth - width, behavior: 'smooth'});
        setLeftBtnShow(true);
        setRightBtnShow(false);
        scrollDom.style.marginLeft = '60px';
    };

    const navScrollEventListener = () => {
        const scrollDom = document.querySelector('.nav-scroll ul');
        const width = scrollDom.getBoundingClientRect().width;

        if (scrollDom.scrollLeft === 0) {
            setLeftBtnShow(false);
            scrollDom.style.marginLeft = '0';
        } else if (scrollDom.scrollLeft + width === scrollDom.scrollWidth) {
            setRightBtnShow(false);
        } else {
            scrollDom.style.marginLeft = '60px';
            setRightBtnShow(true);
            setLeftBtnShow(true);
        }
    };

    useEffect(() => {
        const scrollDom = document.querySelector('.nav-scroll ul');
        navScrollEventListener();
        scrollDom.addEventListener('scroll', navScrollEventListener);
        return () => {
            scrollDom.removeEventListener('scroll', navScrollEventListener);
        };
    }, []);

    // 获取用户登录信息
    useEffect(() => {
        userinfo.init(info => {
            info.hasLogin && setUserInfo(info);
            // loginSuccess && loginSuccess(info);
        });
    }, []);

    useEffect(() => {
        const loginHref = `https://login.bce${env === 'SANDBOX' ? 'test' : ''}.baidu.com/${
            props.needQualify ? '?needQualify=1' : ''
        }`;
        // 如果是跳转到console页面，打开登录弹窗后再跳转
        const clickHandler = e => {
            const consoleHref = findConsoleHref(e.target);
            if (consoleHref) {
                e.preventDefault();
                Ioc(UDynamicService).open({
                    component: ULoginModal,
                    props: {
                        maskClosable: true,
                        href: loginHref,
                        onOk: info => {
                            if (info.activateSuccess || info.regSuccess) {
                                userinfo.init(
                                    () => {
                                        pushProduct2Crm().finally(() => {
                                            location.href = consoleHref;
                                            // window.open(consoleHref, '_blank');
                                        });
                                    },
                                    false,
                                    true
                                );
                            } else {
                                location.href = consoleHref;
                            }
                        }
                    }
                });
            }
        };
        if (!userInfo?.hasLogin && !isMobile) {
            document.addEventListener('click', clickHandler);
        }
        return () => {
            document.removeEventListener('click', clickHandler);
        };
    }, [userInfo, isMobile]);

    useEffect(() => {
        const header = document.querySelector('.qf-header');
        const headerWrapper = document.querySelector('.qf-header-wrapper');
        const banner = bannerRef.current.base.getBoundingClientRect();
        const handleScrollFn = () => {
            const body = document.querySelector('body');
            const type = props.type;
            // 弹窗登录框出现时，scrollTop为0；导致header位置不对
            if (body.classList.contains('header-body-no-scroll')) {
                return;
            }
            var scrollTop = document.documentElement.scrollTop;
            if (scrollTop > offset) {
                header.classList.add('qf-header-fixed');
            } else {
                header.classList.remove('qf-header-fixed');
            }
            if (type === 'modelBuilder') {
                if (scrollTop >= banner.height - 100 && scrollTop < banner.height) {
                    header.style = `position: absolute;
                        top: ${12 - (scrollTop - banner.height + 100)}px`;
                } else if (scrollTop >= banner.height) {
                    header.style = `position: absolute;
                        top: -62px`;
                } else if (scrollTop === 0) {
                    header.style = 'position: fixed;top: 0';
                } else {
                    header.style = 'position: fixed;top: 12px';
                }
            } else {
                if (scrollTop === 0) {
                    header.style = 'position: fixed;top: 0';
                } else {
                    header.style = 'position: fixed;top: 12px';
                }
            }

            if (scrollTop > 10) {
                headerWrapper.style = 'height: 0px';
            } else {
                headerWrapper.style = 'height: 60px';
            }
        };
        window.addEventListener('scroll', handleScrollFn);
    }, []);

    // 头部右箭头显示控制
    useEffect(() => {
        const wh = screenWidth;
        if (wh > 767) {
            if (wh < 1332) {
                setRightBtnShow(true);
            } else {
                setRightBtnShow(false);
            }
        } else {
            setRightBtnShow(false);
        }
    }, [screenWidth]);

    return (
        <div className="no_rem-qf-header qf-header-wrapper" id="qf-header">
            <div className="qf-header">
                <a className="header-left" href="https://qianfan.cloud.baidu.com/">
                    <div
                        className="logo-wrapper"
                        data-track-category="新官网PC-吸顶"
                        data-track-name="文字链"
                        data-track-value="百度智能云千帆"
                    >
                        <img src={logo} alt="logo" className="logo" />
                    </div>
                </a>
                {leftBtnShow && (
                    <div className="nav-btn-wraper nav-btn-wraper-left ">
                        <div className="nav-btn nav-btn-left" onClick={() => handleScrollLeftClick()}>
                            {nav_btn_left}
                        </div>
                    </div>
                )}
                <div className="header-nav nav-scroll">
                    <ul className="header-nav-list">
                        {navList.map(item => {
                            return (
                                <li className="header-link" key={item.id}>
                                    <a href={item.link} target="_blank" rel="noopener noreferrer" {...item.trackInfo}>
                                        {item.text}
                                    </a>
                                </li>
                            );
                        })}
                    </ul>
                </div>
                {rightBtnShow && (
                    <div className="nav-btn-wraper nav-btn-wraper-right">
                        <div className="nav-btn nav-scroll-right" onClick={() => handleScrollRightClick()}>
                            {nav_btn_right}
                        </div>
                    </div>
                )}
                <div className="header-right">
                    {buttonGroupRight.map(item => {
                        // 已登录态，显示用户名
                        if (item.id === 1 && userInfo?.hasLogin && userInfo.displayName) {
                            return (
                                // eslint-disable-next-line max-len
                                <div
                                    className="header-user"
                                    onMouseEnter={handleMouseEnter}
                                    onMouseLeave={handleMouseLeave}
                                >
                                    <div className="menu-root">
                                        {/* eslint-disable-next-line max-len */}
                                        <span className="name-logo name-logo-dark">
                                            {userInfo?.displayName?.slice(0, 1)}
                                        </span>
                                        <span className="menu-parent-title-user">{userInfo?.displayName}</span>
                                        {ArrowIcon}
                                        <div className="menu-popover">
                                            <div className="menu-popover-box">
                                                <a
                                                    className="menu-popover-item"
                                                    href={`https://login.bce${
                                                        env === 'SANDBOX' ? 'test' : ''
                                                    }.baidu.com/logout?redirect=${window.location.href}`}
                                                    rel="noopener noreferrer"
                                                >
                                                    退出
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        }
                        // 登录态没有注册按钮
                        if (item.id === 2 && userInfo?.hasLogin) {
                            return;
                        }
                        if (item.id === 0) {
                            return <PopoverItem item={item} key={item.id} />;
                        }
                        return (
                            <a
                                key={item.id}
                                href={item.href}
                                target="_self"
                                rel="noopener noreferrer"
                                className={item.class}
                                {...item.trackInfo}
                                onClick={e => {
                                    if (item.id === 1) {
                                        const url = `https://login.bce${env === 'SANDBOX' ? 'test' : ''}.baidu.com/${
                                            props.needQualify ? '?needQualify=1' : ''
                                        }`;
                                        // 登录
                                        handleLogin(e, url);
                                    } else if (item.id === 2) {
                                        const url = `https://login.bce${
                                            env === 'SANDBOX' ? 'test' : ''
                                        }.baidu.com/new-reg`;
                                        // 注册
                                        handleLogin(e, url);
                                    }
                                }}
                            >
                                {item.text}
                            </a>
                        );
                    })}
                </div>
                <div className="header-right-mobile">
                    {userInfo?.hasLogin ? (
                        <div className="header-login">
                            <div className="header-menu-user" onClick={handleUserClick}>
                                {logoutShow ? (
                                    <div className="close-icon">
                                        <img src={closeMenu} alt="操作" />
                                    </div>
                                ) : (
                                    <div className="user-icon"> {userInfo?.displayName?.slice(0, 1)}</div>
                                )}
                            </div>
                            <div className="mobile-menu-popover">
                                <div className="menu-popover-box hover-cls">
                                    <a
                                        className="menu-popover-item"
                                        href={`https://login.bce${
                                            env === 'SANDBOX' ? 'test' : ''
                                        }.baidu.com/logout?redirect=${href}`}
                                        rel="noopener noreferrer"
                                    >
                                        退出
                                    </a>
                                </div>
                                <div className="menu-popover-mask" onClick={handleUserClick}></div>
                            </div>
                        </div>
                    ) : (
                        <div className="header-user-icon">
                            <a
                                onClick={e => {
                                    e.preventDefault();
                                    const url = `https://login.bce${
                                        env === 'SANDBOX' ? 'test' : ''
                                    }.baidu.com/?redirect=${href}`;
                                    window.open(url, '_self');
                                }}
                            >
                                <img src={mbUser} alt="user" />
                            </a>
                        </div>
                    )}
                    <div className="header-menu-root">
                        <div className="header-menu" onClick={handleMenuClick}>
                            <img src={isMenuShow ? mbMenu : closeMenu} alt="操作" />
                        </div>
                        <div className="menu-popover-wrapper">
                            <div className="menu-popover hover-cls">
                                {navList.map((item, index) => {
                                    /* eslint-disable */
                                    return (
                                        <div className="menu-popover-item" key={index}>
                                            <a href={item.link} target="_blank" {...item.trackInfo}>
                                                {item.text}
                                            </a>
                                        </div>
                                    );
                                })}
                            </div>
                            <div className="menu-popover-mask" onClick={handleMenuClick}></div>
                        </div>
                    </div>
                    <div className="back-btn-mobile">
                        <a href={backInfo.href} {...backInfo.trackInfo} target="_blank" rel="noopener noreferrer">
                            <img src={backIconMobile} alt="返回智能云" />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Header;
